"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortItem = exports.isDisableSelectAll = exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var SurveyReact = _interopRequireWildcard(require("survey-react-ui"));
var Survey = _interopRequireWildcard(require("survey-core"));
var _lodash = _interopRequireDefault(require("lodash"));
var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));
var _select = _interopRequireDefault(require("../../../select"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var isDisableSelectAll = function isDisableSelectAll(internalQuestion, normalOptions) {
  if (!normalOptions) {
    return false;
  }
  if (internalQuestion.activeChoices.length > normalOptions.length) {
    return true;
  }
  var isDisableItem = normalOptions.find(function (item) {
    return item.isDisabled;
  });
  if (isDisableItem) {
    return true;
  }
  if (!internalQuestion.maxSelectedChoices) {
    return false;
  }
  if (normalOptions.length > internalQuestion.maxSelectedChoices) {
    return true;
  }
  return false;
};
exports.isDisableSelectAll = isDisableSelectAll;
var sortItem = function sortItem(activeChoiceItems, choiceOptionSort) {
  var newListOptions = [];
  switch (choiceOptionSort) {
    case 'desc':
      {
        newListOptions = _lodash.default.sortBy(activeChoiceItems, ['text']).reverse();
        break;
      }
    case 'asc':
      {
        newListOptions = _lodash.default.sortBy(activeChoiceItems, ['text']);
        break;
      }
    case 'random':
      {
        newListOptions = Survey.Helpers.randomizeArray(activeChoiceItems);
        break;
      }
    default:
      {
        newListOptions = activeChoiceItems;
      }
  }
  return newListOptions;
};
exports.sortItem = sortItem;
var CustomQuestionCheckbox = function CustomQuestionCheckbox(props) {
  var question = props.question,
    isDisplayMode = props.isDisplayMode,
    multi = props.multi,
    placeholder = props.placeholder;
  var _React$useState = _react.default.useState([]),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    itemOptions = _React$useState2[0],
    setItemOptions = _React$useState2[1];
  var _React$useState3 = _react.default.useState([]),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    normalItems = _React$useState4[0],
    setNormalItems = _React$useState4[1];
  var _React$useState5 = _react.default.useState(null),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    selectAll = _React$useState6[0],
    setSelectAll = _React$useState6[1];
  var _React$useState7 = _react.default.useState(null),
    _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
    optionNone = _React$useState8[0],
    setOptionNone = _React$useState8[1];
  var _React$useState9 = _react.default.useState(null),
    _React$useState10 = (0, _slicedToArray2.default)(_React$useState9, 2),
    optionOther = _React$useState10[0],
    setOptionOther = _React$useState10[1];
  var _React$useState11 = _react.default.useState(undefined),
    _React$useState12 = (0, _slicedToArray2.default)(_React$useState11, 2),
    valueSelected = _React$useState12[0],
    setValueSelected = _React$useState12[1];
  var _React$useState13 = _react.default.useState(false),
    _React$useState14 = (0, _slicedToArray2.default)(_React$useState13, 2),
    isCheckedOther = _React$useState14[0],
    setIsCheckedOther = _React$useState14[1];
  var wrapperRef = _react.default.useRef(null);

  /**
   * Update option items based on selected value
   * @param {Array} selectedValue
   * @param {Array} optionItems
   * @param {object} allItem
   * @param {object} noneItem
   * @param {object} otherItem
   */
  var initialItems = function initialItems(selectedValue, optionItems, allItem, noneItem, otherItem) {
    var otherSelected = false;
    if (selectedValue.includes(allItem)) {
      setValueSelected(optionItems);
      setItemOptions([noneItem, otherItem]);
    } else if (selectedValue.includes(noneItem)) {
      setValueSelected([noneItem]);
      setItemOptions([]);
    } else if (selectedValue.includes(otherItem)) {
      setValueSelected(selectedValue);
      var remainItems = optionItems.filter(function (item) {
        return !selectedValue.includes(item);
      });
      setItemOptions([allItem].concat((0, _toConsumableArray2.default)(remainItems), [noneItem]));
      otherSelected = true;
    } else {
      if (optionItems.length === selectedValue.length) {
        setItemOptions([noneItem, otherItem]);
      } else {
        var _remainItems = optionItems.filter(function (item) {
          return !selectedValue.includes(item);
        });
        if (_remainItems.length === optionItems.length && selectedValue.length > 0) {
          // In case no option in list options of question which was choosed
          // but item exist in selected value => It should Other option
          // and no options display
          otherSelected = true;
          setItemOptions([]);
        } else {
          setItemOptions([allItem].concat((0, _toConsumableArray2.default)(_remainItems), [noneItem, otherItem]));
        }
      }
      setValueSelected(selectedValue);
    }
    setIsCheckedOther(otherSelected);
  };
  var buildListItems = function buildListItems(internalQuestion, defaultValue) {
    var allItem;
    var noneItem;
    var otherItem;
    var options = [];
    var choiceOptionSort = internalQuestion.propertyHash.choicesOrder;
    var activeChoiceItems = internalQuestion.activeChoices;
    var listItem = sortItem(activeChoiceItems, choiceOptionSort);
    var isDisabledNormalItem = internalQuestion.maxSelectedChoices && internalQuestion.selectedItems.length >= internalQuestion.maxSelectedChoices;
    var filterOptionItems = !!listItem && listItem.filter(function (item) {
      return item.isVisible;
    });
    var normalOptions = !!filterOptionItems && filterOptionItems.map(function (item) {
      return {
        value: item.value,
        label: item.text,
        isDisabled: !item.isEnabled || isDisabledNormalItem
      };
    });
    setNormalItems(normalOptions);
    options = (0, _toConsumableArray2.default)(normalOptions);
    if (internalQuestion.hasSelectAll) {
      allItem = {
        value: internalQuestion.selectAllItem.value,
        label: internalQuestion.selectAllItem.text,
        isDisabled: isDisableSelectAll(internalQuestion, normalOptions)
      };
      setSelectAll(allItem);
      options = [allItem].concat((0, _toConsumableArray2.default)(options));
    }
    if (internalQuestion.hasNone) {
      noneItem = {
        value: internalQuestion.noneItem.value,
        label: internalQuestion.noneItem.text
      };
      setOptionNone(noneItem);
      options = [].concat((0, _toConsumableArray2.default)(options), [noneItem]);
    }
    if (internalQuestion.hasOther) {
      otherItem = {
        value: internalQuestion.otherItem.value,
        label: internalQuestion.otherItem.text
      };
      setOptionOther(otherItem);
      options = [].concat((0, _toConsumableArray2.default)(options), [otherItem]);
    }
    if (multi) {
      if (Array.isArray(defaultValue)) {
        /**
         * convert props default to default selected items
         */
        var listItems = !!internalQuestion.activeChoices && internalQuestion.activeChoices.map(function (item) {
          return item.value;
        });
        var defaultItems = defaultValue.map(function (item) {
          if (allItem && allItem.value === item) {
            return allItem;
          }
          if (noneItem && noneItem.value === item) {
            return noneItem;
          }
          if (otherItem && otherItem.value === item) {
            return otherItem;
          }
          if (listItems && listItems.includes(item)) {
            return normalOptions.find(function (opt) {
              return opt.value === item;
            });
          }
          // It should select Other option with comment is text item
          if (otherItem) {
            return {
              value: item,
              label: otherItem.label,
              isDisabled: !otherItem.isEnabled
            };
          }
          return {};
        }).filter(function (item) {
          return !_lodash.default.isEmpty(item) && !_lodash.default.isUndefined(item);
        });
        initialItems(defaultItems, normalOptions, allItem, noneItem, otherItem);
      } else {
        setValueSelected(null);
        setItemOptions(options);
      }
    } else if (defaultValue) {
      var selectedValue = options.find(function (el) {
        return el.value === defaultValue;
      });
      if (!selectedValue && otherItem) {
        selectedValue = otherItem;
      }
      setIsCheckedOther(selectedValue && selectedValue === otherItem);
      setItemOptions(options);
      if (selectedValue === undefined || selectedValue.isDisabled === undefined) {
        setValueSelected(selectedValue);
      } else {
        setValueSelected(null);
      }
    } else {
      setValueSelected(null);
      setItemOptions(options);
    }
  };

  /**
   * Update selectedValue and options item when value changed
   * @param {Object} selectedValue
   */
  var _onChange = function onChange(selectedValue) {
    if (!selectedValue) {
      buildListItems(question, null);
      setIsCheckedOther(false);
    } else if (!multi) {
      setValueSelected(selectedValue);
      setIsCheckedOther(selectedValue.value === question.otherItem.value);
    } else {
      initialItems(selectedValue, normalItems, selectAll, optionNone, optionOther);
    }
  };
  var listenAndScrollSelectMenuIntoView = function listenAndScrollSelectMenuIntoView() {
    if (!wrapperRef || !wrapperRef.current) {
      return;
    }
    var menu = wrapperRef.current.querySelector('.react-select__menu');
    if (!menu) {
      return;
    }
    var observerOptions = {
      root: null,
      rootMargin: '0px'
    };
    var intersectionCallback = function intersectionCallback(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 1) {
          (0, _scrollIntoViewIfNeeded.default)(entry.target, {
            behavior: 'smooth'
          });
          if (entry.intersectionRect.top >= entry.boundingClientRect.top && entry.intersectionRect.bottom <= entry.boundingClientRect.bottom) {
            observer.unobserve(entry.target);
          }
        } else {
          observer.unobserve(entry.target);
        }
      });
    };
    new IntersectionObserver(intersectionCallback, observerOptions).observe(menu);
  };
  var onMenuOpen = function onMenuOpen() {
    // register scrollIntoView to run before the next repaint
    window.requestAnimationFrame(function () {
      listenAndScrollSelectMenuIntoView();
    });
  };
  (0, _react.useEffect)(function () {
    if (question) {
      var newValue = _lodash.default.clone(_lodash.default.isEmpty(question.value) ? question.defaultValue : question.value);
      buildListItems(question, newValue);
      question.visibleChoicesChangedCallback = function () {
        buildListItems(question, question.value);
      };
      question.onItemValuePropertyChanged.add(function () {
        buildListItems(question, question.value);
      });
    }
  }, [question]);

  /**
   * Show/hide other input comment
   */
  (0, _react.useEffect)(function () {
    if (!_lodash.default.isUndefined(valueSelected)) {
      // Update rendered value for question to render data when survey was completed
      var newValue = valueSelected && valueSelected.value;
      var internalQuestion = props.question;
      if (Array.isArray(valueSelected)) {
        newValue = valueSelected.map(function (item) {
          return item.value;
        });
      }
      internalQuestion.renderedValue = newValue;
    }
  }, [valueSelected]);
  var backToDefaultValue = function backToDefaultValue() {
    question.setDefaultValue();
    if (_lodash.default.isEmpty(question.value)) {
      buildListItems(question, null);
      setIsCheckedOther(false);
    } else {
      buildListItems(question, question.value);
    }
  };
  (0, _react.useEffect)(function () {
    // Back to default value when is read-only status change
    if (question.isReadOnly) {
      backToDefaultValue();
    }
  }, [question.isReadOnly]);
  (0, _react.useEffect)(function () {
    return function () {
      // Back to default value when component unmount
      backToDefaultValue();
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    ref: wrapperRef,
    className: "multi-select-field"
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    value: valueSelected,
    options: itemOptions,
    className: "select-multi ".concat(question.errors.length ? 'error-field' : ''),
    name: question.name,
    onChange: function onChange(selectedValue) {
      return _onChange(selectedValue);
    },
    onMenuOpen: onMenuOpen,
    autosize: true,
    multi: multi,
    removeSelected: multi,
    closeOnSelect: !multi,
    placeholder: props.t(placeholder),
    disabled: question.isReadOnly,
    menuPlacement: "bottom"
  })), isCheckedOther && /*#__PURE__*/_react.default.createElement("div", {
    className: "select-other-option"
  }, /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionCommentItem, {
    question: question,
    otherCss: question.cssClasses.other,
    cssClasses: question.cssClasses,
    isDisplayMode: isDisplayMode
  })));
};
CustomQuestionCheckbox.propTypes = {
  question: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    cssClasses: _propTypes.default.shape({
      other: _propTypes.default.string.isRequired
    }).isRequired,
    onItemValuePropertyChanged: _propTypes.default.func,
    visibleChoicesChangedCallback: _propTypes.default.func,
    errors: _propTypes.default.instanceOf(Array).isRequired,
    renderedValue: _propTypes.default.string.isRequired,
    defaultValue: _propTypes.default.string.isRequired,
    value: _propTypes.default.string,
    otherItem: _propTypes.default.shape({
      value: _propTypes.default.string
    }),
    isReadOnly: _propTypes.default.bool,
    setDefaultValue: _propTypes.default.func.isRequired,
    isVisible: _propTypes.default.bool,
    activeChoices: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired,
  isDisplayMode: _propTypes.default.string.isRequired,
  multi: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  t: _propTypes.default.func
};
CustomQuestionCheckbox.defaultProps = {
  multi: false,
  placeholder: 'Enter text example',
  t: function t(x) {
    return x;
  }
};
var _default = CustomQuestionCheckbox;
exports.default = _default;